import { useMoveToCurrentPriceModal } from "@shared/features/trades/common/hooks";
import { displayResultMessage } from "utils/misc";
import Modal from "common/Modal/Modal";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import Text from "common/Typography/Text";
import { TradeData } from "@shared/types";
import React from "react";

interface MoveToCurrentPriceModalProps {
  tradeData?: TradeData;
  closeModal: () => void;
  isVisible?: boolean;
}

const MoveToCurrentPriceModal = ({
  tradeData,
  closeModal,
  isVisible,
}: MoveToCurrentPriceModalProps) => {
  const { title, onSubmit, contentIsLoading, actionIsLoading, description } =
    useMoveToCurrentPriceModal({
      tradeData: isVisible ? tradeData : undefined,
      displayResultMessage,
      closeModal,
    });

  const content = contentIsLoading ? (
    <LoadingSpinnerOverlay
      isLoading={true}
      wrap={true}
      wrapStyle={{ height: 30 }}
    />
  ) : (
    <Text>{description}</Text>
  );

  return (
    <Modal
      onCancel={closeModal}
      open={isVisible}
      title={title}
      onOk={onSubmit}
      okButtonProps={{ loading: actionIsLoading }}
      destroyOnHidden={true}
    >
      {content}
    </Modal>
  );
};

export default React.memo(MoveToCurrentPriceModal);
